import React, { useEffect, useState } from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Img_1 from '../../images/3.jpg';
import { FaLocationDot } from "react-icons/fa6";
import Location from '../../modal/Location';
import * as colors from "../../assets/css/Colors";
import { FaStar } from "react-icons/fa";
import './style.css';
import { MdOutlineMenuBook } from "react-icons/md";
import { Link } from "react-router-dom";

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';

const Bloge = () => {
   // Start color change auto function
   const [colorScheme, setColorScheme] = useState(
    window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  );
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      setColorScheme(e.matches ? 'dark' : 'light');
    };
    mediaQuery.addEventListener('change', handleChange);
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);
  // End color change auto function
  const [pincode, setPincode] = useState('');
  const [error, setError] = useState(null);

  const handleLocationUpdate = async (updatedLocation) => {
    try {
      const pincodeMatch = updatedLocation.match(/\b\d{6}\b/);
      const newPincode = pincodeMatch ? pincodeMatch[0] : '';
      setPincode(newPincode);
    } catch (error) {
      setError(error.message);
    }
  };
  const boxstyleqrcode = {
    border: `2px solid ${colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color}`,
    borderRadius: '8px',
  };
  const stylereview = {
    backgroundColor: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color,
    border: `1px solid ${colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color}`,
  }
  return (
    <section style={{marginBottom:'60px'}}>
        <div className='loctionbuttonhide'>
  <Location onLocationUpdate={handleLocationUpdate}/>
  </div>
        <Container>
            <Row>
            <div className="home-tit">
            <h2><span> Detailed Information on Local Area</span> <form onSubmit={(e) => e.preventDefault()}>
            <input
              type="text" className='popuple-data-count-pincode' style={boxstyleqrcode}
              value={pincode}
              onChange={(e) => setPincode(e.target.value)}
              placeholder="Pincode"
            />
          </form><span>&nbsp;Blogs </span></h2>
          <p>Which local area's information would you like to know? Enter the pincode of that local area where a pincode (6 digits) is already available.</p>
          <p>Discover a range of local blogs covering various topics, including community news, insights, and personal stories. Stay informed and engaged with content relevant to your area.</p>
        </div>
                <div className="plac-hom-all-pla hom-more-modu">

                <Swiper
      spaceBetween={15}
      slidesPerView={3}
      onSlideChange={() => console.log('slide change')}
      onSwiper={(swiper) => console.log(swiper)}
    >
 <SwiperSlide>
          <div className="listing-item listing_carditem">
                                                    <article className="geodir-category-listing fl-wrap">
                                                        <div className="geodir-category-img">
                                                          
                                                            <a href="listing-single.html" className="geodir-category-img-wrap fl-wrap">
                                                            <img src={Img_1}/>
                                                            </a>
                                                         
                                                            <div className="geodir-category-opt">
                                                                <div className="geodir-category-opt_title">
                                                                    <h4>
                                                                        <a href="listing-single.html">The Goggi Restaurant</a>
                                                                    </h4>
                                                                    <div className="geodir-category-location">
                                                                       
                                                                        <FaLocationDot />
                                                                            34-42 Montgomery St , NY, USA
                                                                       
                                                                    </div>
                                                                </div>
                                                                <div className="listing-rating-count-wrap">
                                                                    <div className="review-score" style={stylereview}>4.1</div>
                                                                    <div className="listing-rating card-popup-rainingvis">
                                                                    <FaStar />
                                                                    <FaStar />
                                                                    <FaStar />
                                                                    <FaStar />
                                                                    <FaStar />
                                                                    </div>
                                                                    <br></br>
                                                                    <div className="reviews-count">26 reviews</div>
                                                                </div>
                                                                <div className="listing_carditem_footer fl-wrap">
                                                                    <a className="listing-item-category-wrap" href="#">
                                                                        <div className="listing-item-category red-bg">
                                                                        <MdOutlineMenuBook />
                                                                        </div>
                                                                        <span>Restaurants</span>
                                                                    </a>
                                                                    <div className="post-author">
                                                                        <a href="#">
                                                                        <img src={Img_1}/>
                                                                            <span>By , Alisa Noory</span>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </article>
                                                </div>
                                                </SwiperSlide>

    </Swiper>
        </div>
        </Row>
        <div className='view-more-button'>
        <Link to="/Card">
          <span className="btn-ser-need-ani Add-Any-Equation" style={{ backgroundColor: colorScheme === 'dark' ? colors.theme_black_color : colors.theme_white_color }}>More Information of Your Local Area</span>
        </Link>
      </div>
    </Container>
</section>
  )
}

export default Bloge